import { differenceInSeconds, format, formatDistanceStrict } from 'date-fns';

const SECONDS_IN_A_DAY = 86400;

export const formatRelativeDate = (lastUpdatedDate: Date): string => {
	const currentDate = new Date();

	const isDateFormatRelative =
		differenceInSeconds(currentDate, lastUpdatedDate) <= SECONDS_IN_A_DAY;

	return isDateFormatRelative
		? formatDistanceStrict(lastUpdatedDate, currentDate, {
				addSuffix: true,
				roundingMethod: 'floor',
			})
		: format(lastUpdatedDate, 'd MMM, HH:mm');
};
